const React = require('react');
const createClass = require('create-react-class');
const DaysView = require('./DaysView');

const CalendarContainer = createClass({
  render() {
    return React.createElement(DaysView, this.props.viewProps);
  },
});

module.exports = CalendarContainer;



// WEBPACK FOOTER //
// ./src/components/datepicker/src/CalendarContainer.js